// external imports
import React from 'react'
// local imports
import { primaryColor, darkGrey } from '~/colors'

const Indicator = ({ active, ...unused }) =>
    active ? <span style={styles.active} {...unused} /> : <span style={styles.inactive} {...unused} />

const indicatorStyle = {
    height: 12,
    width: 12,
    marginRight: 4,
    borderRadius: '50%',
    cursor: 'pointer'
}

const styles = {
    active: {
        ...indicatorStyle,
        backgroundColor: darkGrey
    },
    inactive: {
        ...indicatorStyle,
        backgroundColor: primaryColor
    }
}

export default Indicator



// WEBPACK FOOTER //
// ./src/components/Slideshow/Indicator.js